import { render } from "./footerH5.vue?vue&type=template&id=1d90c3f5&scoped=true"
import script from "./footerH5.vue?vue&type=script&lang=js"
export * from "./footerH5.vue?vue&type=script&lang=js"

import "./footerH5.vue?vue&type=style&index=0&id=1d90c3f5&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d90c3f5"]])

export default __exports__